import './styles.scss';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ClipLoader } from 'react-spinners';

interface LoadingOverlayProps {
    pending: boolean;
    message?: string;
    styleClassName?: string;
    errorMessage?: string;
    color?: 'accent' | 'black';
}

export function LoadingOverlay(props: LoadingOverlayProps): JSX.Element {
    const accent = '#ee7012';
    return (
        <div className={`${props.styleClassName} appLoadingScreen`}>
            {props.pending ? (
                <>
                    <ClipLoader color={props.color || accent} />
                    <span className="loadingMessage">
                        <FormattedMessage id={props.message ? props.message : 'appLoadingApplicationIntialization'} />
                    </span>
                </>
            ) : (
                <></>
            )}
            {props.errorMessage && (
                <>
                    <ClipLoader color={props.color || accent} />
                    <span className="loadingMessage">
                        <FormattedMessage id="appLoadingApplicationIntializationError" />
                        <p className="color-danger">{props.errorMessage}</p>
                    </span>
                </>
            )}
        </div>
    );
}
